export default __webpack_public_path__ + "static/media/manaswita.a128a601.jpeg";